import _extends from '@babel/runtime/helpers/esm/extends';
var r,
  B = r || (r = {});
B.Pop = "POP";
B.Push = "PUSH";
B.Replace = "REPLACE";
var C = "production" !== process.env.NODE_ENV ? function (b) {
  return Object.freeze(b);
} : function (b) {
  return b;
};
function D(b, h) {
  if (!b) {
    "undefined" !== typeof console && console.warn(h);
    try {
      throw Error(h);
    } catch (e) {}
  }
}
function E(b) {
  b.preventDefault();
  b.returnValue = "";
}
function F() {
  var b = [];
  return {
    get length() {
      return b.length;
    },
    push: function push(h) {
      b.push(h);
      return function () {
        b = b.filter(function (e) {
          return e !== h;
        });
      };
    },
    call: function call(h) {
      b.forEach(function (e) {
        return e && e(h);
      });
    }
  };
}
function H() {
  return Math.random().toString(36).substr(2, 8);
}
function I(b) {
  var h = b.pathname;
  h = void 0 === h ? "/" : h;
  var e = b.search;
  e = void 0 === e ? "" : e;
  b = b.hash;
  b = void 0 === b ? "" : b;
  e && "?" !== e && (h += "?" === e.charAt(0) ? e : "?" + e);
  b && "#" !== b && (h += "#" === b.charAt(0) ? b : "#" + b);
  return h;
}
function J(b) {
  var h = {};
  if (b) {
    var e = b.indexOf("#");
    0 <= e && (h.hash = b.substr(e), b = b.substr(0, e));
    e = b.indexOf("?");
    0 <= e && (h.search = b.substr(e), b = b.substr(0, e));
    b && (h.pathname = b);
  }
  return h;
}
function createBrowserHistory(b) {
  function h() {
    var c = p.location,
      a = m.state || {};
    return [a.idx, C({
      pathname: c.pathname,
      search: c.search,
      hash: c.hash,
      state: a.usr || null,
      key: a.key || "default"
    })];
  }
  function e(c) {
    return "string" === typeof c ? c : I(c);
  }
  function x(c, a) {
    void 0 === a && (a = null);
    return C(_extends({
      pathname: q.pathname,
      hash: "",
      search: ""
    }, "string" === typeof c ? J(c) : c, {
      state: a,
      key: H()
    }));
  }
  function z(c) {
    t = c;
    c = h();
    v = c[0];
    q = c[1];
    d.call({
      action: t,
      location: q
    });
  }
  function A(c, a) {
    function f() {
      A(c, a);
    }
    var l = r.Push,
      k = x(c, a);
    if (!g.length || (g.call({
      action: l,
      location: k,
      retry: f
    }), !1)) {
      var n = [{
        usr: k.state,
        key: k.key,
        idx: v + 1
      }, e(k)];
      k = n[0];
      n = n[1];
      try {
        m.pushState(k, "", n);
      } catch (G) {
        p.location.assign(n);
      }
      z(l);
    }
  }
  function y(c, a) {
    function f() {
      y(c, a);
    }
    var l = r.Replace,
      k = x(c, a);
    g.length && (g.call({
      action: l,
      location: k,
      retry: f
    }), 1) || (k = [{
      usr: k.state,
      key: k.key,
      idx: v
    }, e(k)], m.replaceState(k[0], "", k[1]), z(l));
  }
  function w(c) {
    m.go(c);
  }
  void 0 === b && (b = {});
  b = b.window;
  var p = void 0 === b ? document.defaultView : b,
    m = p.history,
    u = null;
  p.addEventListener("popstate", function () {
    if (u) g.call(u), u = null;else {
      var c = r.Pop,
        a = h(),
        f = a[0];
      a = a[1];
      if (g.length) {
        if (null != f) {
          var l = v - f;
          l && (u = {
            action: c,
            location: a,
            retry: function retry() {
              w(-1 * l);
            }
          }, w(l));
        } else "production" !== process.env.NODE_ENV ? D(!1, "You are trying to block a POP navigation to a location that was not created by the history library. The block will fail silently in production, but in general you should do all navigation with the history library (instead of using window.history.pushState directly) to avoid this situation.") : void 0;
      } else z(c);
    }
  });
  var t = r.Pop;
  b = h();
  var v = b[0],
    q = b[1],
    d = F(),
    g = F();
  null == v && (v = 0, m.replaceState(_extends({}, m.state, {
    idx: v
  }), ""));
  return {
    get action() {
      return t;
    },
    get location() {
      return q;
    },
    createHref: e,
    push: A,
    replace: y,
    go: w,
    back: function back() {
      w(-1);
    },
    forward: function forward() {
      w(1);
    },
    listen: function listen(c) {
      return d.push(c);
    },
    block: function block(c) {
      var a = g.push(c);
      1 === g.length && p.addEventListener("beforeunload", E);
      return function () {
        a();
        g.length || p.removeEventListener("beforeunload", E);
      };
    }
  };
}
;
function createHashHistory(b) {
  function h() {
    var a = J(m.location.hash.substr(1)),
      f = a.pathname,
      l = a.search;
    a = a.hash;
    var k = u.state || {};
    return [k.idx, C({
      pathname: void 0 === f ? "/" : f,
      search: void 0 === l ? "" : l,
      hash: void 0 === a ? "" : a,
      state: k.usr || null,
      key: k.key || "default"
    })];
  }
  function e() {
    if (t) c.call(t), t = null;else {
      var a = r.Pop,
        f = h(),
        l = f[0];
      f = f[1];
      if (c.length) {
        if (null != l) {
          var k = q - l;
          k && (t = {
            action: a,
            location: f,
            retry: function retry() {
              p(-1 * k);
            }
          }, p(k));
        } else "production" !== process.env.NODE_ENV ? D(!1, "You are trying to block a POP navigation to a location that was not created by the history library. The block will fail silently in production, but in general you should do all navigation with the history library (instead of using window.history.pushState directly) to avoid this situation.") : void 0;
      } else A(a);
    }
  }
  function x(a) {
    var f = document.querySelector("base"),
      l = "";
    f && f.getAttribute("href") && (f = m.location.href, l = f.indexOf("#"), l = -1 === l ? f : f.slice(0, l));
    return l + "#" + ("string" === typeof a ? a : I(a));
  }
  function z(a, f) {
    void 0 === f && (f = null);
    return C(_extends({
      pathname: d.pathname,
      hash: "",
      search: ""
    }, "string" === typeof a ? J(a) : a, {
      state: f,
      key: H()
    }));
  }
  function A(a) {
    v = a;
    a = h();
    q = a[0];
    d = a[1];
    g.call({
      action: v,
      location: d
    });
  }
  function y(a, f) {
    function l() {
      y(a, f);
    }
    var k = r.Push,
      n = z(a, f);
    "production" !== process.env.NODE_ENV ? D("/" === n.pathname.charAt(0), "Relative pathnames are not supported in hash history.push(" + JSON.stringify(a) + ")") : void 0;
    if (!c.length || (c.call({
      action: k,
      location: n,
      retry: l
    }), !1)) {
      var G = [{
        usr: n.state,
        key: n.key,
        idx: q + 1
      }, x(n)];
      n = G[0];
      G = G[1];
      try {
        u.pushState(n, "", G);
      } catch (K) {
        m.location.assign(G);
      }
      A(k);
    }
  }
  function w(a, f) {
    function l() {
      w(a, f);
    }
    var k = r.Replace,
      n = z(a, f);
    "production" !== process.env.NODE_ENV ? D("/" === n.pathname.charAt(0), "Relative pathnames are not supported in hash history.replace(" + JSON.stringify(a) + ")") : void 0;
    c.length && (c.call({
      action: k,
      location: n,
      retry: l
    }), 1) || (n = [{
      usr: n.state,
      key: n.key,
      idx: q
    }, x(n)], u.replaceState(n[0], "", n[1]), A(k));
  }
  function p(a) {
    u.go(a);
  }
  void 0 === b && (b = {});
  b = b.window;
  var m = void 0 === b ? document.defaultView : b,
    u = m.history,
    t = null;
  m.addEventListener("popstate", e);
  m.addEventListener("hashchange", function () {
    var a = h()[1];
    I(a) !== I(d) && e();
  });
  var v = r.Pop;
  b = h();
  var q = b[0],
    d = b[1],
    g = F(),
    c = F();
  null == q && (q = 0, u.replaceState(_extends({}, u.state, {
    idx: q
  }), ""));
  return {
    get action() {
      return v;
    },
    get location() {
      return d;
    },
    createHref: x,
    push: y,
    replace: w,
    go: p,
    back: function back() {
      p(-1);
    },
    forward: function forward() {
      p(1);
    },
    listen: function listen(a) {
      return g.push(a);
    },
    block: function block(a) {
      var f = c.push(a);
      1 === c.length && m.addEventListener("beforeunload", E);
      return function () {
        f();
        c.length || m.removeEventListener("beforeunload", E);
      };
    }
  };
}
;
function createMemoryHistory(b) {
  function h(d, g) {
    void 0 === g && (g = null);
    return C(_extends({
      pathname: t.pathname,
      search: "",
      hash: ""
    }, "string" === typeof d ? J(d) : d, {
      state: g,
      key: H()
    }));
  }
  function e(d, g, c) {
    return !q.length || (q.call({
      action: d,
      location: g,
      retry: c
    }), !1);
  }
  function x(d, g) {
    u = d;
    t = g;
    v.call({
      action: u,
      location: t
    });
  }
  function z(d, g) {
    var c = r.Push,
      a = h(d, g);
    "production" !== process.env.NODE_ENV ? D("/" === t.pathname.charAt(0), "Relative pathnames are not supported in memory history.push(" + JSON.stringify(d) + ")") : void 0;
    e(c, a, function () {
      z(d, g);
    }) && (m += 1, p.splice(m, p.length, a), x(c, a));
  }
  function A(d, g) {
    var c = r.Replace,
      a = h(d, g);
    "production" !== process.env.NODE_ENV ? D("/" === t.pathname.charAt(0), "Relative pathnames are not supported in memory history.replace(" + JSON.stringify(d) + ")") : void 0;
    e(c, a, function () {
      A(d, g);
    }) && (p[m] = a, x(c, a));
  }
  function y(d) {
    var g = Math.min(Math.max(m + d, 0), p.length - 1),
      c = r.Pop,
      a = p[g];
    e(c, a, function () {
      y(d);
    }) && (m = g, x(c, a));
  }
  void 0 === b && (b = {});
  var w = b;
  b = w.initialEntries;
  w = w.initialIndex;
  var p = (void 0 === b ? ["/"] : b).map(function (d) {
      var g = C(_extends({
        pathname: "/",
        search: "",
        hash: "",
        state: null,
        key: H()
      }, "string" === typeof d ? J(d) : d));
      "production" !== process.env.NODE_ENV ? D("/" === g.pathname.charAt(0), "Relative pathnames are not supported in createMemoryHistory({ initialEntries }) (invalid entry: " + JSON.stringify(d) + ")") : void 0;
      return g;
    }),
    m = Math.min(Math.max(null == w ? p.length - 1 : w, 0), p.length - 1),
    u = r.Pop,
    t = p[m],
    v = F(),
    q = F();
  return {
    get index() {
      return m;
    },
    get action() {
      return u;
    },
    get location() {
      return t;
    },
    createHref: function createHref(d) {
      return "string" === typeof d ? d : I(d);
    },
    push: z,
    replace: A,
    go: y,
    back: function back() {
      y(-1);
    },
    forward: function forward() {
      y(1);
    },
    listen: function listen(d) {
      return v.push(d);
    },
    block: function block(d) {
      return q.push(d);
    }
  };
}
;
export { r as Action, createBrowserHistory, createHashHistory, createMemoryHistory, I as createPath, J as parsePath };